import { z } from 'zod';
import { PageSchema } from './PaginatedListResponse.js';
import { QualityStatusSchema, SessionStatusSchema, UuidSchema } from './common.js';
import { TranscriptResponseSchema } from './Transcripts.js';
const SessionIdsSchema = z
    .array(UuidSchema)
    .min(1)
    .max(100)
    .superRefine((sessionIds, ctx) => {
    if (new Set(sessionIds).size !== sessionIds.length) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'sessionIds must be unique',
        });
    }
});
export const TranscriptQueryBySessionIdsSchema = z
    .object({
    sessionIds: SessionIdsSchema,
})
    .strict();
export const TranscriptQueryByFilterSchema = z
    .object({
    projectId: UuidSchema,
    organizationId: UuidSchema.optional(),
    status: SessionStatusSchema.optional(),
    qualityStatus: QualityStatusSchema.optional(),
    limit: z.number().multipleOf(1).positive().max(100).prefault(20),
    offset: z.number().multipleOf(1).nonnegative().prefault(0),
})
    .strict();
export const TranscriptQuerySchema = z.union([
    TranscriptQueryBySessionIdsSchema,
    TranscriptQueryByFilterSchema,
]);
export const TranscriptListFoundItemSchema = z.object({
    sessionId: UuidSchema,
    status: z.literal('found'),
    transcript: TranscriptResponseSchema,
});
export const TranscriptListMissingItemSchema = z.object({
    sessionId: UuidSchema,
    status: z.enum(['transcript_not_found', 'session_not_found']),
});
export const TranscriptListItemSchema = z.union([
    TranscriptListFoundItemSchema,
    TranscriptListMissingItemSchema,
]);
export const TranscriptListResponseSchema = z.object({
    items: z.array(TranscriptListItemSchema),
    meta: z.object({
        requestedCount: z.number().multipleOf(1).nonnegative(),
        foundCount: z.number().multipleOf(1).nonnegative(),
        transcriptNotFoundCount: z.number().multipleOf(1).nonnegative(),
        sessionNotFoundCount: z.number().multipleOf(1).nonnegative(),
    }),
    page: PageSchema.optional(),
});
//# sourceMappingURL=TranscriptQueries.js.map